import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Spin } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import { getTranslation } from "../../../utils/helper";

const ContactsFilterForm = ({ isFetching, query, onSubmit }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const [form] = Form.useForm();

  const nameField = "name";
  const nameValue = query[nameField];

  const phoneField = "phone";
  const phoneValue = query[phoneField];

  const addressField = "address";
  const addressValue = query[addressField];

  useEffect(() => {
    form.setFieldsValue({
      [nameField]: nameValue,
      [phoneField]: phoneValue,
      [addressField]: addressValue,
    });
  }, [query, form]);

  const handleSubmit = values => {
    const params = {};
    params[nameField] = values[nameField] || null;
    params[phoneField] = values[phoneField] || null;
    params[addressField] = values[addressField] || null;
    onSubmit({ ...query, ...params }, true);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <Form form={form} onFinish={handleSubmit} className="FilterForm ContactsFilterForm" layout="vertical">
        <div className="FilterFormContent">
          <Row gutter={16}>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Contacts", "Name")} name={nameField}>
                <Input size="large" placeholder={getTranslation(setting, "Contacts", "Name")} />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Contacts", "Phone Number")} name={phoneField}>
                <Input size="large" placeholder={getTranslation(setting, "Contacts", "Phone Number")} />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 8 }}>
              <Form.Item label={getTranslation(setting, "Contacts", "Address")} name={addressField}>
                <Input size="large" placeholder={getTranslation(setting, "Contacts", "Address")} />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="FilterFormActions">
          <Button size="large" type="text" onClick={handleResetButton}>
            {getTranslation(setting, "Common", "Reset")}
            <ReactSVG className="icon" src="/icons/reset.svg" />
          </Button>
          <Button size="large" type="primary" htmlType="submit">
            {getTranslation(setting, "Common", "Apply")}
            <ReactSVG className="icon" src="/icons/apply.svg" />
          </Button>
        </div>
      </Form>
    </Spin>
  );
};

export default ContactsFilterForm;
